import React from 'react'
import { useTranslation } from 'react-i18next'
import LogoutIcon from '@mui/icons-material/Logout'
import AccountCircleIcon from '@mui/icons-material/AccountCircle'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import ListItemIcon from '@mui/material/ListItemIcon'

import { useAuth } from '../../../../hooks/useAuth'
import { StaffAccountButton, StaffAccountButtonText } from '../Drawer.styled'

interface StaffAccountMenuProps {
  userDisplayName: string
}

const StaffAccountMenu: React.FC<StaffAccountMenuProps> = ({ userDisplayName }) => {
  const { t } = useTranslation()
  const { logout } = useAuth()
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null)

  const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const handleMenuClose = () => {
    setAnchorEl(null)
  }

  const handleLogout = () => {
    handleMenuClose()
    logout()
  }

  return (
    <>
      <StaffAccountButton
        color="inherit"
        aria-label={t('header.accountMenu')}
        aria-controls={anchorEl ? 'staff-account-menu' : undefined}
        aria-haspopup="menu"
        aria-expanded={anchorEl ? 'true' : undefined}
        onClick={handleMenuOpen}
        startIcon={<AccountCircleIcon />}
        endIcon={<KeyboardArrowDownIcon />}
      >
        <StaffAccountButtonText>{userDisplayName || t('header.account')}</StaffAccountButtonText>
      </StaffAccountButton>
      <Menu id="staff-account-menu" anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleMenuClose}>
        <MenuItem onClick={handleLogout}>
          <ListItemIcon>
            <LogoutIcon fontSize="small" />
          </ListItemIcon>
          {t('header.logout')}
        </MenuItem>
      </Menu>
    </>
  )
}

export default StaffAccountMenu
